import { FC } from "react";
import { DataProvider } from "../../leopart-update/context/DataContext";
import TeamDetail from "../../leopart-update/pages/TeamDetail";
import PlayerDetail from "../../leopart-update/pages/PlayerDetail";
import Analysis from "../../leopart-update/pages/Analysis";
import { Routes, Route, NavLink } from "react-router-dom";

const LeopartApp: FC = () => {
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        background: "white",
        overflow: "hidden",
      }}
    >
      <PlayerDetail playerId="698a2ec57aa6abc3d66c0b80" />
    </div>
  );
};

const TestPage: FC = () => {
  return (
    <DataProvider>
      <LeopartApp />
    </DataProvider>
  );
};

export default TestPage;
